export default __webpack_public_path__ + "static/media/invitation-bg3.6836bc05.gif";